module.exports = {
    "page.im.window.filter.all": "ทั้งหมด",
    "page.import.tab.template": "ประวัติของรูปแบบ",
    "lazada_im_sticker_thankyou": "ขอบคุณจ้า",
    "page.im.window.app.download": "ใช้แอพพลิเคชั่นเพื่อแชทกับเราได้ดีขึ้น",
    "lazada_im_sticker_buybuybuy": "ซื้อ ซื้อ ซื้อ!",
    "page.import.tab.history": "Import History",
    "page.im.window.tab.product": "สินค้า",
    "page.im.window.oversize": "ไฟล์มีขนาดใหญ่เกินกว่าที่จะอัปโหลด (เล็กกว่า 50 M)",
    "page.import.importBox.importButton": "อัปโหลดไฟล์",
    "page.im.window.messageInputPlaceholder": "พิมพ์ข้อความที่นี่, กดตกลงเพื่อส่งข้อความ",
    "im.messageList.productTitle": "ข้อมูลสินค้า",
    "page.import.historyBox.col.action": "ดำเนินการ",
    "page.im.window.defaultText": "ประเภทข้อความที่ไม่รู้จัก",
    "page.im.setting.btn.clear": "ล้างข้อมูลที่เลือกไว้",
    "page.im.window.label.shopSku": "SKU ของร้านค้า",
    "page.import.importBox.infos.3": "รูปแบบรหัส : UTF-8, separator: semicolon",
    "page.im.window.sessionFilterPlaceholder": "ค้นหาชื่อลูกค้า...",
    "page.im.window.label.total": "ทั้งหมด",
    "page.im.window.label.message": "Chat",
    "page.import.historyBox.col.progress": "กำลังดำเนินการ",
    "lazada_im_sticker_peep": "ดูอย่างเงียบๆ",
    "im.messageList.payNow": "Pay Now",
    "page.im.setting.tab3": "ตอบกลับอัตโนมัติ",
    "page.import.historyBox.col.user": "ผู้ใช้",
    "page.im.window.orderSearchPlaceholder": "กรุณาใส่เลขที่สั่งซื้อ",
    "page.im.window.filter.unread": "ยังไม่อ่าน",
    "page.import.historyBox.col.created": "สร้าง",
    "page.import.importBox.infos.2": "หมายเหตุ: ไฟล์ Excel อาจไม่มีสูตรหรืออ้างอิงใด ๆ",
    "im.messageList.confirm": "ที่อยู่จัดส่งถูกต้อง",
    "page.import.tab.import": "นำเข้า",
    "im.messageList.change": "เปลี่ยน",
    "page.im.window.disconnection": "เครือข่ายการเชื่อมต่อ",
    "im.messageList.totalReturns": "สินค้าที่ถูกคืนทั้งหมด",
    "page.im.window.label.totalItems": "รายการทั้งหมด",
    "page.im.window.label.emptyMessage": "ไม่มีข้อความที่ได้รับ",
    "page.im.window.draft": "ร่าง",
    "page.import.historyBox.feedback.success": "การนำเข้าข้อมูลของคุณเสร็จสิ้น",
    "im.messageList.reviewShippingInformationItemTip": "รายการสินค้าทั้งหมด",
    "lazada_im_sticker_vouchers": "คูปอง",
    "im.messageList.unpaidOrderTitle": "แจ้งเตือนถึงคำสั่งซื้อที่ยังไม่ได้ทำการชำระเงิน",
    "page.im.setting.title": "ปรับระบบ Chat",
    "im.messageList.returnRequestTitle": "คำขอคืนสินค้า",
    "im.messageList.lazMall": "LazMall",
    "page.im.window.view": "ดู",
    "lazada_im_sticker_shoppingday": "วันช้อปปิ้ง",
    "page.im.setting.imForm.to": "ถึง",
    "page.im.window.voucher.sendBatch.creatingTitle": "สร้างคูปองส่วนลดใหม่",
    "page.im.window.label.orderTime": "เวลาสั่งซื้อ",
    "page.im.window.voucher.sendBatch.creatingDesc": "กรุณาอย่าปิดหน้าต่างนี้ ไม่อย่างนั้นคูปองส่วนลดจะไม่ถูกส่ง\r\nกดยืนยันเมื่อคุณสร้างส่วนลดในหน้าต่างใหม่สำเร็จ",
    "page.im.window.voucher.sendBatch.submitError": "ส่งคูปองส่วนลดสำหรับผู้ติดตามไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    "page.im.window.label.totalReturns": "Total returns",
    "page.im.setting.init.confirm": "เมื่อมีการกำหนดบัญชีหลักของการแชทแล้ว คุณไม่สามารถแก้ไขหรือลบทิ้งได้ กรุณาตรวจสอบให้แน่ใจว่าคุณได้ส่งบัญชีที่ถูกต้องแล้ว",
    "page.im.window.label.emptyList": "โอ้ไม่มี,ผู้ซื้อhasn'tซื้อสิ่งใดจากร้านค้าของคุณยัง",
    "im.messageList.orderDate": "วันที่สั่งซื้อ",
    "page.im.window.label.pending": "อยู่ระหว่างดำเนินการ",
    "page.im.window.date.yesterday": "เมื่อวานนี้",
    "im.messageList.reviewShippingInformationTitle": "ตรวจสอบที่อยู่จัดส่งของคุณ",
    "page.im.setting.imForm.from": "จาก",
    "page.im.window.voucher.sendBatch.submitSuccess": "คูปองส่วนลดสำหรับผู้ติดตามจะถูกส่งในอีกไม่กี่นาที",
    "page.im.window.discount.cashLabelPrefixLine2": "าเงิน",
    "im.messageList.reviewShippingInformationAddress": "ที่อยู่จัดส่ง",
    "im.messageList.followBtn": "ติดตาม",
    "page.im.window.label.order": "คำสั่งซื้อ",
    "page.im.window.voucher.sendBatch.title": "ส่งคููปองส่วนลดให้ผู้ติดตามมากว่า 1 คน",
    "im.messageList.status": "สถานะ",
    "page.im.window.discount.rateLabel": "%",
    "page.im.window.label.status": "สถานะ",
    "page.im.window.voucher.sendBatch.creatingButton": "สร้างคูปองส่วนลดใหม่",
    "page.import.footer.button.done": "เสร็จสิ้น",
    "page.im.window.discount.cashLabelSuffix": "ลด",
    "page.import.historyBox.feedback.failed": "การนำเข้าข้อมูลของคุณผิดพลาด",
    "page.im.window.get": "แถม",
    "page.import.importBox.templateTitle": "ดาวน์โหลดเทมเพลต",
    "page.import.historyBox.link.download": "ดาวน์โหลด",
    "page.im.setting.btn.remove": "ลบออก",
    "page.im.window.prdSearchPlaceholder": "กรุณาใส่ชื่อสินค้า",
    "im.messageList.unpaidOrderItemTip": "สินค้าทั่งหมด",
    "page.import.importBox.infos.1": "สำหรับการสร้างหรืออัปโหลดสินค้า คุณสามารถใช้ ไฟล์ CSV (.csv) หรือ MS Excel (.xlsx)",
    "page.im.window.tab.collectiveVoucher": "คูปอง Collective Voucher",
    "im.messageList.failedStatus": "การส่งข้อความล้มเหลว {resend} หรือ {delete}",
    "page.import.historyBox.col.status": "สถานะ",
    "lazada_im_sticker_no": "ไม่",
    "page.im.setting.tab1": "การจัดการผู้ใช้",
    "page.im.window.follow.send": "ส่งคำเชิญ",
    "lazada_im_sticker_ok": "ตกลง",
    "page.im.window.voucher.sendBatch.createButton": "สร้างคูปองส่วนลดใหม่",
    "page.im.window.process.resend": "ส่งใหม่อีกครั้ง",
    "lazada_im_sticker_giftforyou": "ของขวัญสำหรับคุณ",
    "page.im.window.discount.cashLabelPrefixLine1": "มูลค่",
    "lazada_im_sticker_kisses": "จุ๊บ",
    "page.import.historyBox.col.processed": "ดำเนินการแล้ว",
    "im.messageList.orderNumber": "หมายเลขคำสั่งซื้อ",
    "page.im.setting.btn.createUser": "สร้างผู้ใช้ใหม่พร้อมสิทธิการเข้าถึงเต็มรูปแบบ",
    "page.import.importBox.importModeText": "Import Mode",
    "page.im.setting.management.title": "ฝ่ายสนับสนุนให้บริการลูกค้า",
    "page.im.window.voucher.sendBatch.errorTip": "เกิดความผิดพลาด :(",
    "page.im.window.label.all": "ทั้งหมด",
    "im.messageList.whereIsMyOrderTitle": "คำสั่งซื้อล่าสุด",
    "page.im.window.units": "หน่วย",
    "page.import.importBox.footerTips": "รายละเอียดสินค้าที่ทำการอัพเดทด้วยการใช้อัพโหลดแบบกลุ่ม (Bulk Upload) จะไม่แสดงให้เห็นใน Lorikeet โปรดดาวน์โหลดไฟล์ Excel เพื่อดูรายละเอียดสินค้า",
    "page.im.setting.confirm": "คุณแน่ใจหรือไม่ว่าต้องการลบผู้ใช้ออกจากกลุ่มนี้",
    "page.im.window.label.unread": "ยังไม่อ่าน",
    "page.im.window.voucher.sendBatch.desc": "คุณกำลังจะส่งคูปองส่วนลดสำหรับผู้ติดตามให้ผู้ติดตามของคุณ",
    "page.im.window.label.productName": "ชื้อสินค้า",
    "page.im.window.follow": "ติดตาม",
    "page.im.window.read": "อ่าน",
    "page.im.setting.assignment.title": "กำหนดบัญชีแชทหลักของคุณ",
    "page.im.window.tab.order": "ใบสั่ง",
    "page.im.setting.assignment.placeholder": "อีเมล, ชื่อผู้ใช้",
    "im.messageList.returnReason": "เหตุผลในการคืนสินค้า",
    "page.im.window.label.loading": "กำลังโหลด",
    "page.im.setting.btn.addUser": "เพิ่มผู้ใช้",
    "page.im.window.follow.notFollow": "ลูกค้ายังไม่ได้ติดตามร้านของคุณ",
    "im.messageList.view": "ดูเพิ่มเติม",
    "im.messageList.unknowMessage": "โปรดตรวจสอบข้อความนี้ใน Lazada App ของคุณ",
    "page.import.footer.button.another": "นำเข้าข้อมูลเพิ่มเติม",
    "im.messageList.followTitle": "ติดตามร้านค้า",
    "page.im.window.unread": "ยังไม่อ่าน",
    "page.im.window.send": "ส่ง",
    "page.im.window.filter.read": "อ่าน",
    "im.messageList.order": "คำสั่งซื้อ",
    "page.import.historyBox.col.type": "ชื่อไฟล์",
    "page.im.window.label.sellerSku": "สินค้าจากร้านค้า",
    "page.im.setting.assignment.subTitle": "กรุณากำหนดบัญชีที่จะเป็นผู้รับผิดชอบแชทของคุณ โดยบัญชีนี้จะเป็นแอคเคาท์เดียวที่สามารถเห็นข้อความแชททั้งหมดของคุณได้ในกรณีที่คุณมีผู้ใช้งานมากกว่า 1 บัญชี\r\nหมายเหตุ : บัญชีนี้จะไม่สามารถแก้ไขได้เมื่อทำการยืนยันแล้ว",
    "page.im.window.label.read": "อ่าน",
    "page.im.setting.btn.selectAll": "จากทุกหน้า",
    "page.im.window.label.refresh": "รีเฟรช",
    "page.im.setting.current.desc": "จากทุกหน้าที่เลือกไว้",
    "page.im.setting.tab2": "ข้อความตอบกลับอย่างรวดเร็ว",
    "page.im.window.translation.advertisements": "Alibaba Translation",
    "lazada_im_sticker_like": "โอเค",
    "page.im.window.voucher.sendBatch.choose": "กรุณาเลือกคูปองสำหรับผู้ติดตามเพื่อส่ง",
    "im.messageList.voucherBtn": "เก็บ"
};